import { fromJS } from "immutable";
import types from "./types";

export const initialState = fromJS({
  token: null,
  isValid: false,
  validationErrors: {},
  runValidation: false,
});

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case types.SET_VALIDITY: {
      return state.set("isValid", action.validity);
    }

    case types.SET_TOKEN: {
      return state.set("token", action.token);
    }

    case types.SET_VALIDATION_ERRORS: {
      return state.set("validationErrors", fromJS(action.errors || {}));
    }

    case types.SET_TRIGGER_VALIDATION: {
      return state.set("runValidation", action.bool);
    }

    default: {
      return state;
    }
  }
};
